import React, { useState } from "react"
import CommonTitle from "components/common/CommonTitle"
import Layout from "components/Layout/Layout"
import { Box } from "@mui/material"
import styles from "./styles.module.scss"
/**
 * メンテナンス画面
 */
const Maintenance = () => {
  return (
    <Layout>
      <Box className={styles.nonStepBarWrap}>
        <h2 className={styles.title}>
          恐れ入ります、
          <br />
          ただいまメンテナンス中です。
        </h2>
      </Box>
    </Layout>
  )
}

export default Maintenance
